import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import React__default from 'react';
import { api, login } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import '../../../../../lazy-image/legacy-lazy-image/index.js';
import { LazyImage } from '../../../../../lazy-image/lazy-image/index.js';
import '../../../../../utils/fetcher.js';
import { prependPrefix } from '../../../../../utils/style.js';
import { logout } from '../../../api/user-center.js';
import { useHeaderContext } from '../../../context.js';

var DEFAULT_ICON = "".concat(api.MISSEVAN_CDN_PREFIX_URL, "/avatars/icon01.png");
var NAV_MAP = [{
  key: 'home',
  name: '主站',
  url: api.MISSEVAN_MOBILE_API_PREFIX_URL
}, {
  key: 'fm',
  name: '直播',
  url: api.MISSEVAN_FM_API_PREFIX_URL
}, {
  key: 'wallet-m',
  name: '钱包',
  url: "".concat(api.MISSEVAN_MOBILE_API_PREFIX_URL, "/wallet")
}];
var UserMenu = function UserMenu(_ref) {
  var _context;

  var isShow = _ref.isShow;

  var _useHeaderContext = useHeaderContext(),
      user = _useHeaderContext.user;

  var handleLoginClick = function handleLoginClick() {
    login.gotoLogin();
  };

  var handleLogoutClick = function handleLogoutClick() {
    logout();
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(prependPrefix('user-menu'), {
      'menu-visiable': isShow
    })
  }, user ? /*#__PURE__*/React__default.createElement("a", {
    className: "menu-item menu-userinfo",
    href: _concatInstanceProperty(_context = "".concat(api.MISSEVAN_MOBILE_API_PREFIX_URL, "/")).call(_context, user.id)
  }, /*#__PURE__*/React__default.createElement(LazyImage, {
    src: user.boardiconurl2,
    className: "user-avatar"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "user-info"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "user-name"
  }, user.username), /*#__PURE__*/React__default.createElement("p", null, "M\u53F7\uFF1A", user.id), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("span", null, "\u94BB\u77F3\uFF1A", user.balance || 0), /*#__PURE__*/React__default.createElement("span", null, "\u5C0F\u9C7C\u5E72\uFF1A", user.point || 0)))) : /*#__PURE__*/React__default.createElement("a", {
    className: "menu-item menu-userinfo",
    onClick: handleLoginClick
  }, /*#__PURE__*/React__default.createElement(LazyImage, {
    src: DEFAULT_ICON,
    className: "user-avatar"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "user-info"
  }, "\u70B9\u51FB\u767B\u5F55")), _mapInstanceProperty(NAV_MAP).call(NAV_MAP, function (_ref2) {
    var key = _ref2.key,
        name = _ref2.name,
        url = _ref2.url;
    return /*#__PURE__*/React__default.createElement("a", {
      className: "menu-item menu-icon",
      key: key,
      href: url
    }, /*#__PURE__*/React__default.createElement("i", {
      className: key
    }), name);
  }), user && /*#__PURE__*/React__default.createElement("div", {
    className: "menu-item menu-logout",
    onClick: handleLogoutClick
  }, "\u9000\u51FA\u767B\u5F55"));
};

export { UserMenu };
